"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_intl_1 = require("react-intl");
const MESSAGES = (0, react_intl_1.defineMessages)({
    somethingWrong: {
        id: 'Alerts.somethingWrong',
        defaultMessage: 'Something went wrong!',
    },
});
exports.default = MESSAGES;
